/*
 * App.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import React from 'react';

import AppBar from './AppBar';
import Content from './Content';
import ImprintContainer from '../containers/ImprintContainer';
import Matomo from './core/Matomo';
import SurveyContainer from '../containers/core/SurveyContainer';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {darkTheme} from '../themes/dark.js';
import CssBaseline from '@material-ui/core/CssBaseline';


/**
 * Die App ist die Rootebene des Bildungsmanagers
 */
class App extends React.Component {

    render() {
        return (
            <MuiThemeProvider theme={darkTheme}>
                <CssBaseline />

                <div>
                    <AppBar/>
                    <Content/>
                    {
                        this.props.trackingEnabled ? <Matomo/> : <span/>
                    }
                    <ImprintContainer/>
                    <SurveyContainer/>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/de/ergovia/components/App.jsx